module.exports = __webpack_public_path__ + "img/advantage-item-04.c08f6277.png";